import { useClientAccountOverview } from '@ukpostbox/client-data';
import { Badge, Colour, Placement, useLayout } from '@ukpostbox/frontend-framework';
import { useLayoutStore } from '@ukpostbox/frontend-framework/lib/Providers/Stores/LayoutStore';
import React from 'react';
import { NavigationUnreadBadgeType } from './NavigationTypes';

function NavigationUnreadBadge(props: NavigationUnreadBadgeType) {
	const overview = useClientAccountOverview();
	const { isUltraWide } = useLayout();

	const sidebarOpen = useLayoutStore((state) => state.sidebarOpen);

	if (
		!overview?.data?.counts.mailItems?.unread ||
		overview?.data?.counts.mailItems?.unread === 0 ||
		!overview?.data?.counts.messages?.unread ||
		overview?.data?.counts.messages?.unread === 0
	) {
		return null;
	}

	return (
		<Badge
			colour={Colour.Alert}
			value={
				props.name === 'mail' ? overview?.data?.counts.mailItems.unread : overview?.data?.counts.messages.unread
			}
			placement={sidebarOpen || isUltraWide ? Placement.CenterRight : Placement.TopRight}
		/>
	);
}

export { NavigationUnreadBadge };
